import { __assign } from "tslib";
export var COMPONENTS_DATA_HOOKS = {
    ANCHORS: 'anchors',
};
export var DATA_HOOKS = __assign(__assign({}, COMPONENTS_DATA_HOOKS), { BREADCRUMBS: 'breadcrumbs', KB_SUBHEADER: 'kb-sub-header', SCROLL_SPY_ANCHOR: 'scroll-spy-anchor', ANCHORS_SCROLL_TO_TOP: 'anchors-scroll-to-top' });
//# sourceMappingURL=dataHooks.js.map